import React from "react";
import API from "../base/API";
import { Row, Col, Panel } from 'react-bootstrap';
import { translate } from "../base/Translation";

export default class UserAgreementEdit extends React.Component {

    constructor(props) {
        super(props);

        this.api = new API({
            upload_user_agreement: "/user/agreement/upload?user=:user",
            delete_user_agreement: "/user/agreement/delete/:agreementID"
        });

        this.state = {
            agreements: this.props.user.agreements
        };
    }

    upload(evt) {
        if (this.refs.attachment.files.length < 1) {
            alert(translate("Vyberete súbor"));
            return;
        }

        if (this.refs.type.value === "0") {
            alert(translate("Vyberete typ dokumentu"));
            return;
        }

        this.api.request({
            cache: false,
            route: "upload_user_agreement",
            data: { files: this.refs.attachment.files, type: this.refs.type.value },
            params: { user: this.props.user.id },
            created: (response) => {
                this.setState({ agreements: response.data });
            }
        });
    };

    deleteAgreement() {
        this.component.api.request({
            route: "delete_user_agreement",
            params: { agreementID: this.agreement.id },
            success: (response) => {

                let agreements = this.component.state.agreements;
                agreements = agreements.filter(item => item.id !== this.agreement.id);

                this.component.setState({ agreements });
            }
        })
    }

    renderAgreements() {
        if (!this.state.agreements) {
            return translate("Nieje nahraná žiadna zmluva.");
        }

        return (
            <table className="table table-stripped">
                <thead>
                    <tr>
                        <th>{translate("Typ dokumentu")}</th>
                        <th>{translate("Nahrané")}</th>
                        <th>{translate("Odsúhlasené")}</th>
                        <th>{translate("Možnosti")}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.agreements.map((agreement, index) => {
                        return (
                            <tr key={index}>
                                <td><a href={agreement.url} target="_blank">{translate(agreement.name)}</a></td>
                                <td>{agreement.created}</td>
                                <td>{agreement.agreed ? "Áno" : "Nie"}</td>
                                <td><button className="btn btn-xs btn-danger" onClick={this.deleteAgreement.bind({ component: this, agreement })} > <span className="fa fa-trash" /></button></td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }

    render() {
        return (
            <Panel header={translate("Zmluvy a dokumenty na odsúhlasenie")}>
                {this.renderAgreements()}
                <hr />
                <h4>{translate("Nahrať zmluvu/dokument na odsúhlasenie")}</h4>
                <Row>
                    <Col lg={4}>
                        <select className="form-control" ref="type">
                            <option value={0}>{translate("Vyberte typ dokumentu")}</option>
                            <option value={"contract"}>{translate("Zmluva o spolupráci – Občiansky zákonník")}</option>
                            <option value={"contract_business"}>{translate("Zmluva o spolupráci – Obchodný zákonník")}</option>
                            <option value={"agreement"}>{translate("Dohoda")}</option>
                        </select>
                    </Col>
                    <Col lg={8}>
                        <div className="input-group">
                            <input className="form-control" type="file" name="attachment" ref="attachment" />
                            <div className="input-group-btn">
                                <button onClick={this.upload.bind(this)} className="btn btn-primary">{translate("Nahrať")}</button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Panel>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/user/UserAgreementEdit.jsx